module.exports = __webpack_public_path__ + "img/038-key.8c34c87a.svg";